<mat-sidenav-container
  autosize
  [class.rte-view]="viewContext().isRTEView()"
  [class.dialog-view]="viewContext().isDialogView()"
  [class.management-view]="viewContext().isManagementView()">
  <mat-sidenav mode="side" opened fixedBottomGap="0" fixedTopGap="64" class="file-picker-sidenav" [disableClose]="true">
    @if ((datasource()?.loading$ | async) === false && (datasource()?.empty$ | async) === true) {
      <p>{{ 'Files.Shared.NoneFound' | translate: locale.language }}</p>
    }
    <app-files-search-and-sort [fileSearch]="fileSearch()" [datasource]="datasource()" [viewContext]="viewContext()">
    </app-files-search-and-sort>
    <div class="file-list" [class.with-tenant-search]="isSuperAdmin">
      <mat-selection-list
        [attr.aria-label]="'Files.Shared.SelectionListTip' | translate: locale.language"
        [multiple]="false"
        (selectionChange)="onFileSelected($event)">
        @for (file of datasource()?.data; track file) {
          <mat-list-option [selected]="isSelected(file)" [value]="file">
            @if (isImageFile(file)) {
              <img matListItemAvatar loading="lazy" src="{{ file.PublicUrl }}" alt="{{ file.Description ?? '' }}" />
            } @else {
              <div matListItemAvatar>
                <mat-icon>{{ getIcon(file) }}</mat-icon>
              </div>
            }
            <div matListItemTitle>{{ file.FileName }}</div>
            <div matListItemLine>
              <span>{{ getDate(file) | date: 'short' }}</span>
              <span> - {{ file.FileSize }}</span>
            </div>
          </mat-list-option>
        }
      </mat-selection-list>
    </div>
  </mat-sidenav>
  <mat-sidenav-content
    [class.rte-view]="viewContext().isRTEView()"
    [class.dialog-view]="viewContext().isDialogView()"
    [class.management-view]="viewContext().isManagementView()">
    <div class="file-picker-content">
      @if (!fileToDisplay() && (datasource()?.loading$ | async) === false) {
        <div class="none-selected">
          <b>{{ 'Alert.Attachments.NothingToDisplay' | translate: locale.language }}</b>
        </div>
      }
      @if ((datasource()?.loading$ | async) === false) {
        <app-file-description-input
          [fileDescription]="fileDescription()"
          [fileResize]="fileResize()"
          [fileViewModel]="fileToDisplay()"
          [showSaveButton]="viewContext().isManagementView()"
          [showUseButton]="!viewContext().isManagementView()"
          [showDeleteButton]="viewContext().isManagementView()"
          (fileSelected)="onFileSelectedEvent()"
          (deleteFile)="onFileDeletedEvent()"
          (saveFile)="onFileSavedEvent()"
          (uploadCancelled)="onUploadCancelled()"
          (uploadFile)="onFileUploadConfirmed()">
        </app-file-description-input>
      }
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
